import { TaskTodo } from 'models';
import { toDate, customFormat } from 'utils';

export enum Warning {
  Required = 'Lisää puuttuva tieto',
  SymbolsLimit = 'Kentän maksimi merkkimäärä on 200',
  DescriptionSymbolsLimit = `Kentän maksimi merkkimäärä on 4000`,
}

export function prepareModel(task: TaskTodo) {
  const startDate = toDate(task.StartDate);
  const dueDate = toDate(task.DueDate);

  return {
    Subject: task.Subject,
    Description: task.Description,
    ResolutionDescription: task.ResolutionDescription,
    StartDate: customFormat(startDate, 'server'),
    DueDate: customFormat(dueDate, 'server'),
    Recurring: task.Recurring?.Value,
    ShowOnEventOfBoardMeeting: task.ShowOnEventOfBoardMeeting,
    ShowOnEventOfGeneralMeeting: task.ShowOnEventOfGeneralMeeting,
    ExecutorId: task.Executor?.Id,
    Status: task.Status?.Value,
    Priority: task.Priority?.Value !== undefined ? task.Priority?.Value : null,
  };
}
